
import CardSlash from "../../../assets/duotone/CardSlash.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CardSlashIcon({ className, dataTestid = "CardSlashIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CardSlash data-testid={dataTestid} className={classes} {...rest} />
  );
}
